import apiClient from '@/common/apiClient';

export default {
  getAllLeads() {
    return apiClient.get('/leads');
  },
};
